/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMaxRightIcon32Regular = forwardRef('ArrowDim2DiagMaxRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M19 3a1 1 0 1 0 0 2h6.586l-8.293 8.293a1 1 0 0 0 1.414 1.414L27 6.414V13a1 1 0 1 0 2 0V6a3 3 0 0 0-3-3h-7Z" }),
        React.createElement("path", { d: "M14.708 18.707a1 1 0 0 0-1.415-1.414L5 25.586V19a1 1 0 1 0-2 0v7a3 3 0 0 0 3 3h7a1 1 0 1 0 0-2H6.414l8.294-8.293Z" })));
});
